import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@paljs/ui/Button";
import { InputGroup } from "@paljs/ui/Input";
import { Card, CardBody } from "@paljs/ui";
import { toast } from "react-toastify";
import Fetch from "../components/Fetch";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);
  const [invalidLink, setInvalidLink] = useState(!/^[A-Za-z0-9_-]{43}$/.test(token));

  useEffect(() => {
    // Retira o token da barra e do histórico assim que a tela recebe o link.
    window.history.replaceState(window.history.state, "", window.location.pathname);
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (saving || invalidLink) return;
    if (password !== confirmation) {
      toast.warn("As senhas precisam ser iguais.");
      return;
    }
    setSaving(true);
    try {
      await Fetch.post("/auth/reset-password", { token, password });
      setPassword("");
      setConfirmation("");
      toast.success("Senha alterada. Faça login com sua nova senha.");
      navigate("/login", { replace: true });
    } catch (error) {
      if (error?.response?.status === 400) setInvalidLink(true);
    } finally {
      setSaving(false);
    }
  }

  return (
    <main style={{ maxWidth: 480, margin: "64px auto", padding: 16 }}>
      <Card>
        <CardBody>
          <h1>Definir nova senha</h1>
          {invalidLink ? (
            <p role="alert">Este link é inválido ou expirou. <Link to="/request-password">Solicitar novo link</Link></p>
          ) : (
            <form onSubmit={submit}>
              <p>Use de 12 a 128 caracteres. O link pode ser usado uma única vez.</p>
              <label htmlFor="new-password">Nova senha</label>
              <InputGroup fullWidth>
                <input id="new-password" type="password" autoComplete="new-password" required minLength={12} maxLength={128}
                  value={password} onChange={event => setPassword(event.target.value)} disabled={saving} />
              </InputGroup>
              <label htmlFor="confirm-password">Confirmar nova senha</label>
              <InputGroup fullWidth>
                <input id="confirm-password" type="password" autoComplete="new-password" required minLength={12} maxLength={128}
                  value={confirmation} onChange={event => setConfirmation(event.target.value)} disabled={saving} />
              </InputGroup>
              <Button type="submit" status="Success" fullWidth disabled={saving}>
                {saving ? "Salvando…" : "Salvar nova senha"}
              </Button>
            </form>
          )}
          <p><Link to="/login">Voltar ao login</Link></p>
        </CardBody>
      </Card>
    </main>
  );
}
